export default {
  list: {
    title: '通知一覧',
    messageTitle: '通知一覧',
    viewAll: 'すべて表示',
    searchPlaceholder: 'メッセージ検索',
    markAllRead: 'すべて既読',
    settings: '通知設定',
    totalCount: '合計',
    unreadCount: '未読',
    unit: '件',
    onlyUnread: '未読のみ',
    columns: {
      type: 'タイプ',
      message: 'メッセージ詳細',
      time: 'メッセージ日時',
      operations: '操作'
    },
    operations: {
      markRead: '既読にする',
      markUnread: '未読にする',
      view: '既読に転送'
    }
  },
  tabs: {
    unread: '通知',
    all: 'お知らせ'
  },
  categories: {
    all: '全部',
    job: '求人',
    candidate: '選考'
  },
  status: {
    unread: '未読',
    read: '既読'
  },
  types: {
    // 職位関連
    jobPosted: '求人公開',
    jobOpened: '求人共有',
    jobClosed: '求人クローズ',

    // 選考関連
    newApplication: '新エントリー',
    selectionStageChanged: '選考更新',
    interviewScheduleSent: '面接日程確認待ち',
    interviewScheduleAccepted: '面接日程確定済み',
    interviewSchedulePending: '面接日程再調整依頼',
    interviewScheduleAdjusted: '面接日程調整済み',
    interviewScheduleExpired: '面接日程期限切れ',
    interviewScheduleRescheduled: '面接日程再予約',
    joinDateConfirmed: '入社予定日調整',
    joined: '入社確定',
    selectionTerminated: '選考中止',
    internalMessage: '社内連絡',
    externalContact: '社外連絡',
    offerNoticeSent: '内定通知書送付',
    candidateRegistered: '候補者登録'
  },
  messages: {
    markAllReadSuccess: 'すべて既読にしました',
    markReadSuccess: '既読にしました',
    markUnreadSuccess: '未読にしました',
    viewDetail: '詳細を表示'
  },
  announcementDialog: {
    confirm: '確認しました'
  },
  settings: {
    pageTitle: '通知設定',
    breadcrumb: {
      messageCenter: '通知一覧',
      messageSettings: '通知設定'
    },
    jobSection: '求人',
    candidateSection: '選考',
    selfReceive: '自分が受信するか',
    recipients: '受信対象',
    channels: '受信方法',
    settingButton: '設定',
    onlySuperAdmin: 'この設定は管理者が一括で行います',
    defaultRecipients: '候補者担当、選考担当',
    externalRecipients: '選考担当',
    recipientsCount: '{count}個',
    updateSuccess: '設定を更新しました',
    updateFailed: '設定の更新に失敗しました',
    recipientUpdateSuccess: '受信対象を更新しました',
    recipientUpdateFailed: '受信対象の更新に失敗しました',
    loadFailed: '設定の読み込みに失敗しました'
  },
  recipientDialog: {
    title: '受信設定',
    subtitle: '「{title}」の受信対象を選択してください。',
    searchPlaceholder: '役割/アカウントタイプ/アカウント名で検索',
    defaultSend: 'デフォルトで送信',
    roles: 'タイプ',
    accounts: 'アカウント',
    selected: '選択済み',
    candidateOwner: '候補者担当',
    selectionOwner: '選考担当',
    channels: '受信方法',
    channelInApp: 'システム',
    channelEmail: 'メール',
    channelInAppN: 'システム通知',
    channelEmailN: 'メール通知',
    channelRequired: '受信方法を1つ以上選択してください'
  },
  // メッセージテンプレート
  messageTemplates: {
    // 企業端テンプレート
    jobPublish: '[[userName]] が求人 [[jobTitle]] を公開しました。',
    jobOpen: '求人 [[jobTitle]] を以下の人材紹介会社に共有しました：[[headhunterCompanyNames]]',
    jobClose: '[[userName]] が [[jobTitle]] をクローズしました。',
    newApplication: '求人 [[jobTitle]] への新規エントリーがありました。',
    selectionStatusChange: '候補者 [[candidateName]] さんの選考が [[stepName]] に進みました。',

    interviewScheduleSent: '候補者 [[candidateName]] さんの [[<bold>stepName<bold>]] は日程確定待ちです。',
    interviewScheduleAccepted: '候補者 [[candidateName]] さんの [[<bold>stepName<bold>]] 日程は [[interviewTime]] に確定しました。',
    interviewSchedulePending: '候補者 [[candidateName]] さんの [[<bold>stepName<bold>]] に、日程再調整依頼がありました。',
    interviewScheduleExpired: '候補者[[candidateName]]さんの[[stepName]]候補日程が期限切れとなり、再調整が必要です。',
    interviewScheduleAdjusted: '候補者[[candidateName]]さんの[[stepName]]日程が再調整されました。',
    offerNoticeSent: '候補者 [[candidateName]] さんに、内定通知書が送付されました。<br/>入社予定日：[[joinDate]]',

    selectionTerminate: '候補者 [[candidateName]] さんの選考が [[stepName]] で中止しました。',
    confirmJoinDate: '候補者 [[candidateName]] さんの入社予定日が [[joinDate]] に変更しました。',
    confirmJoin: '候補者 [[candidateName]] さんの入社を確認しました。',



    interviewScheduleRescheduled: '候補者[[candidateName]]さんの[[stepName]]日程が再調整され、日程確認待ち。',

    internalComment: '候補者 [[candidateName]] の 社内連絡 にメッセージがあります。（[[remarkContent]]）<br/>送信者：[[userName]]',
    externalContact: '候補者 [[candidateName]] の 社外連絡 にメッセージがあります。（[[remarkContent]]）<br/>送信者：[[userName]]',
    candidateRegister: '新候補者 [[candidateName]] が登録されました。',
    // 人材紹介会社端テンプレート（productId === 3）
    agent: {
      jobOpen: '[[enterpriseName]] の求人 [[jobTitle]] が貴社に共有されました。',
      jobClose: '[[enterpriseName]] が [[jobTitle]] をクローズしました。',
      newApplication: '候補者 [[candidateName]] を求人 [[jobTitle]] にエントリーしました。',
      selectionStatusChange: '候補者 [[candidateName]] さんの選考が [[<bold>stepName<bold>]] に進みました。',
      selectionTerminate: '候補者 [[candidateName]] さんの選考を [[<bold>stepName<bold>]] で中止しました。',
      confirmJoinDate: '候補者 [[candidateName]] さんの入社予定日が [[<bold>joinDate<bold>]] に変更しました。',
      confirmJoin: '候補者 [[candidateName]] さんの入社を確認しました。',
      interviewScheduleSent: '候補者 [[candidateName]] さんの [[<bold>stepName<bold>]] は日程確定待ちです。',
      interviewScheduleAccepted: '候補者 [[candidateName]] さんの [[<bold>stepName<bold>]] 日程は [[interviewTime]] に確定しました。',
      interviewSchedulePending: '候補者 [[candidateName]] さんの [[<bold>stepName<bold>]] に、日程再調整依頼がありました。',
      interviewScheduleExpired: '候補者[[candidateName]]さんの[[stepName]]候補日程が期限切れとなり、再調整が必要です。',
      interviewScheduleAdjusted: '候補者[[candidateName]]さんの[[stepName]]日程が再調整されました。',
      interviewScheduleRescheduled: '候補者[[candidateName]]さんの[[stepName]]日程が再調整され、日程確認待ち。',
      internalComment: '候補者 [[candidateName]] の 社内連絡 にメッセージがあります。（[[remarkContent]]）<br/>送信者：[[<bold>userName<bold>]]',
      externalContact: '候補者 [[candidateName]] の 社外連絡 にメッセージがあります。（[[remarkContent]]）<br/>送信者：[[<bold>userName<bold>]]',
      candidateRegister: '新しい候補者 [[candidateName]] が登録されました。'
    },
    // 固定文言
    candidateSource: '応募経路：',
    candidateChannel: '応募チャンネル：',
    enterpriseName: '募集企業：',
    requestAdjustTime: '',
    remark: '備考：',
    adjusted: '',
    expired: '',
    awaitingReschedule: '',
    rescheduled: '',
    awaitingConfirm: '',
    confirmedJoin: '',
    terminateStage: '',
    terminateReason: '中止理由：',
    terminated: '',
    stage: ''
  }

};
